import { useEffect } from 'react';

const ROLE_ROUTES = {
  admin: '/admin-dashboard',
  teacher: '/teacher-dashboard',
  student: '/student-dashboard',
};

export default function OAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const role = params.get('role');

    if (token) {
      localStorage.setItem('token', token);

      // Decode the JWT payload to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const userObj = { _id: payload.id, email: payload.email, role: payload.role || role };
        localStorage.setItem('user', JSON.stringify(userObj));
      } catch {
        // payload decode failed, token still stored, profile fetch will handle it
      }

      const destination = ROLE_ROUTES[role] || '/student-dashboard';
      // Hard redirect so useAuth re-initialises from localStorage with the new token
      window.location.replace(destination);
    } else {
      window.location.replace('/login?error=google_auth_failed');
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <p>Signing you in...</p>
    </div>
  );
}
